import Providers from "@/providers";
import { RouterProvider } from "@tanstack/react-router";
import router from "@/config/router";

function App() {
  return (
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  );
}

export default App;
